import { render, staticRenderFns } from "./Back.vue?vue&type=template&id=6c82de25&scoped=true"
import script from "./Back.vue?vue&type=script&lang=js"
export * from "./Back.vue?vue&type=script&lang=js"
import style0 from "./Back.vue?vue&type=style&index=0&id=6c82de25&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c82de25",
  null
  
)

export default component.exports